import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'

import SocialSkillImg1 from '../../assets/ss5.svg'
import SocialSkillImg2 from '../../assets/ss6.svg'


const Services = () => {
  return (
    // <section id="services">
    //   <h5>What I Offer</h5>
    //   <h2>Services</h2>

    //   <div className="container services__container">
    //     <article className="service">
    //       <div className="service__head">
    //         <h3>UI/UX Design</h3>
    //       </div>

    //       <ul className="service__list">
    //         {/* <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>User Research</p>
    //         </li> */}

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Information Architecture</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Wireframing and Prototyping</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Visual Design</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Interaction Design</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Usability Testing</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Responsive and Mobile Design</p>
    //         </li>

    //         {/* <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Collaboration and Communication</p>
    //         </li> */}
          
    //       </ul>

          
    //     </article>

    //     {/* --------------------------------------------- */}

    //     <article className="service">
    //       <div className="service__head">
    //         <h3>Web Development</h3>
    //       </div>

    //       <ul className="service__list">
    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Website Development</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Front-End Development</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Back-End Development</p>
    //         </li>

    //         {/* <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Content Management Systems (CMS)</p>
    //         </li> */}

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>E-commerce Development</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Website Maintenance and Support</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Responsive Design and Mobile Optimization</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Website Optimization and SEO</p>
    //         </li>
          
    //       </ul>

          
    //     </article>

    //   {/* --------------------------------------------- */}

    //     <article className="service">
    //       <div className="service__head">
    //         <h3>Content Creation</h3>
    //       </div>

    //       <ul className="service__list">
    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Blog and Article Writing</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Website Content Development</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Content Strategy and Planning</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Branding and Messaging</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Content Optimization for SEO</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Content Localization</p>
    //         </li>

    //         {/* <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Responsive and Mobile Design: Adapting the design to different devices and screen sizes, ensuring a seamless user experience across desktop, mobile, and tablet devices.</p>
    //         </li>

    //         <li>
    //           <BiCheck className='service__list-icon'/>
    //           <p>Collaboration and Communication</p>
    //         </li> */}
          
    //       </ul>

          
    //     </article>
    //   </div>
    // </section>


    <section id="services">
      <h5>Competencies I have</h5>
      <h2>Social Skills</h2>

      <div className="container services__container">
        <div className='fill__image1'>
          <img src={SocialSkillImg1} alt="" />
        </div>
        
        <article className="service">
          <div className="service__head">
            {/* <h3>UI/UX Design</h3> */}
          </div>

          <ul className="service__list">
            {/* <li>
              <BiCheck className='service__list-icon'/>
              <p>User Research</p>
            </li> */}

            <li>
              <BiCheck className='service__list-icon'/>
              <p>Leadership</p>
            </li>

            <li>
              <BiCheck className='service__list-icon'/>
              <p>Time management</p>
            </li>

            <li>
              <BiCheck className='service__list-icon'/>
              <p>Team work</p>
            </li>

            <li>
              <BiCheck className='service__list-icon'/>
              <p>Continuous learning</p>
            </li>

            <li>
              <BiCheck className='service__list-icon'/>
              <p>Effective communication</p>
            </li>

            <li>
              <BiCheck className='service__list-icon'/>
              <p>Adaptability</p>
            </li>

            <li>
              <BiCheck className='service__list-icon'/>
              <p>Analytical Thinking</p>
            </li>
          
          </ul>

          
        </article>

        {/* --------------------------------------------- */}

        <div className='fill__image2'>
         <img src={SocialSkillImg2} alt="" />
  
        </div>

             
      </div>
    </section>
  )
}

export default Services